import { Box,  Flex, Image } from "@chakra-ui/react";
import React from "react";
import style from "./Iconblock.module.css";

const Iconblock = () => {
  return (
    <div>
      <Flex className={style.flex}>
        <Box className={style.box1}>
          <div className={style.svgdiv1}>
            <svg
              viewBox="0 0 20 20"
              fill=" rgb(255, 21, 138)"
              width="20"
              height="20"
            >
              <path
                d="M8.53033 14.2478L8 13.7175L7.46967 14.2478C7.76256 14.5407 8.23744 14.5407 8.53033 14.2478ZM8 12.6569L4.53033 9.18718C4.23744 8.89429 3.76256 8.89429 3.46967 9.18718C3.17678 9.48008 3.17678 9.95495 3.46967 10.2478L7.46967 14.2478L8 13.7175L8.53033 14.2478L16.2478 6.53033C16.5407 6.23743 16.5407 5.76256 16.2478 5.46967C15.955 5.17677 15.4801 5.17677 15.1872 5.46967L8 12.6569Z"
                fill="currentColor"
                fill-rule="evenodd"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <Image
            src="https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured images/Home Page - 2022 Rebrand/first_fold/icons/design_icon.png"
            w={"50px"}
            h={"50px"}
            m={"auto"}
          />
          <p className={style.p}>
            Creative <br />
            and design
          </p>
        </Box>
        <Box className={style.box2}>
          <div className={style.svgdiv2}>
            <svg
              viewBox="0 0 20 20"
              fill=" rgb(255, 21, 138)"
              width="20"
              height="20"
            >
              <path
                d="M8.53033 14.2478L8 13.7175L7.46967 14.2478C7.76256 14.5407 8.23744 14.5407 8.53033 14.2478ZM8 12.6569L4.53033 9.18718C4.23744 8.89429 3.76256 8.89429 3.46967 9.18718C3.17678 9.48008 3.17678 9.95495 3.46967 10.2478L7.46967 14.2478L8 13.7175L8.53033 14.2478L16.2478 6.53033C16.5407 6.23743 16.5407 5.76256 16.2478 5.46967C15.955 5.17677 15.4801 5.17677 15.1872 5.46967L8 12.6569Z"
                fill="currentColor"
                fill-rule="evenodd"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <Image
            src="https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured images/Home Page - 2022 Rebrand/first_fold/icons/dev_icon.png"
            w={"50px"}
            h={"50px"}
            m={"auto"}
          />
          <p className={style.p}>
            Software <br />
            development
          </p>
        </Box>
        <Box className={style.box3}>
          <div className={style.svgdiv3}>
            <svg
              viewBox="0 0 20 20"
              fill=" rgb(255, 21, 138)"
              width="20"
              height="20"
            >
              <path
                d="M8.53033 14.2478L8 13.7175L7.46967 14.2478C7.76256 14.5407 8.23744 14.5407 8.53033 14.2478ZM8 12.6569L4.53033 9.18718C4.23744 8.89429 3.76256 8.89429 3.46967 9.18718C3.17678 9.48008 3.17678 9.95495 3.46967 10.2478L7.46967 14.2478L8 13.7175L8.53033 14.2478L16.2478 6.53033C16.5407 6.23743 16.5407 5.76256 16.2478 5.46967C15.955 5.17677 15.4801 5.17677 15.1872 5.46967L8 12.6569Z"
                fill="currentColor"
                fill-rule="evenodd"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <Image
            src="https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured images/Home Page - 2022 Rebrand/first_fold/icons/pmo_icon.png"
            w={"50px"}
            h={"50px"}
            m={"auto"}
          />
          <p className={style.p}>
            Project
            <br />
            Management
          </p>
        </Box>
        <Box className={style.box4}>
          <div className={style.svgdiv4}>
            <svg
              viewBox="0 0 20 20"
              fill=" rgb(255, 21, 138)"
              width="20"
              height="20"
            >
              <path
                d="M8.53033 14.2478L8 13.7175L7.46967 14.2478C7.76256 14.5407 8.23744 14.5407 8.53033 14.2478ZM8 12.6569L4.53033 9.18718C4.23744 8.89429 3.76256 8.89429 3.46967 9.18718C3.17678 9.48008 3.17678 9.95495 3.46967 10.2478L7.46967 14.2478L8 13.7175L8.53033 14.2478L16.2478 6.53033C16.5407 6.23743 16.5407 5.76256 16.2478 5.46967C15.955 5.17677 15.4801 5.17677 15.1872 5.46967L8 12.6569Z"
                fill="currentColor"
                fill-rule="evenodd"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <Image
            src="https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured images/Home Page - 2022 Rebrand/first_fold/icons/crm_icon.png"
            w={"50px"}
            h={"50px"}
            m={"auto"}
          />
          <p className={style.p}>
            Sales and
            <br />
            CRM
          </p>
        </Box>
        <Box className={style.box5}>
          <div className={style.svgdiv5}>
            <svg
              viewBox="0 0 20 20"
              fill=" rgb(255, 21, 138)"
              width="20"
              height="20"
            >
              <path
                d="M8.53033 14.2478L8 13.7175L7.46967 14.2478C7.76256 14.5407 8.23744 14.5407 8.53033 14.2478ZM8 12.6569L4.53033 9.18718C4.23744 8.89429 3.76256 8.89429 3.46967 9.18718C3.17678 9.48008 3.17678 9.95495 3.46967 10.2478L7.46967 14.2478L8 13.7175L8.53033 14.2478L16.2478 6.53033C16.5407 6.23743 16.5407 5.76256 16.2478 5.46967C15.955 5.17677 15.4801 5.17677 15.1872 5.46967L8 12.6569Z"
                fill="currentColor"
                fill-rule="evenodd"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <Image
            src="https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured images/Home Page - 2022 Rebrand/first_fold/icons/task_icon.png"
            w={"50px"}
            h={"50px"}
            m={"auto"}
          />
          <p className={style.p}>
            Task
            <br />
            Management
          </p>
        </Box>
        <Box className={style.box6}>
          <div className={style.svgdiv6}>
            <svg
              viewBox="0 0 20 20"
              fill=" rgb(255, 21, 138)"
              width="20"
              height="20"
            >
              <path
                d="M8.53033 14.2478L8 13.7175L7.46967 14.2478C7.76256 14.5407 8.23744 14.5407 8.53033 14.2478ZM8 12.6569L4.53033 9.18718C4.23744 8.89429 3.76256 8.89429 3.46967 9.18718C3.17678 9.48008 3.17678 9.95495 3.46967 10.2478L7.46967 14.2478L8 13.7175L8.53033 14.2478L16.2478 6.53033C16.5407 6.23743 16.5407 5.76256 16.2478 5.46967C15.955 5.17677 15.4801 5.17677 15.1872 5.46967L8 12.6569Z"
                fill="currentColor"
                fill-rule="evenodd"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <Image
            src="https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/Generator_featured images/Home Page - 2022 Rebrand/first_fold/icons/workflows_icon.png"
            w={"50px"}
            h={"50px"}
            m={"auto"}
          />
          <p className={style.p}>
            More
            <br />
            Workflows
          </p>
        </Box>
      </Flex>
    </div>
  );
};

export default Iconblock;
